module.exports = __webpack_public_path__ + "media/56.2ab90d40.mp3";